// Shared design tokens for the Assessment module's shell and dashboard.
export const ACCENT = "#17479e";
export const ACCENT_DARK = "#0f3375";
export const ACCENT_SOFT = "rgba(23,71,158,0.08)";

export const SURFACE = {
  page: "#f5f7fb",
  card: "#ffffff",
  border: "#e6eaf2",
};

export const RADIUS = 14;

export const cardSx = {
  borderRadius: `${RADIUS}px`,
  background: SURFACE.card,
  border: `1px solid ${SURFACE.border}`,
  boxShadow: "0 1px 2px rgba(16,24,40,0.04), 0 4px 16px rgba(16,24,40,0.04)",
};

// Applied once by the shell to every non-dashboard screen so the list screens (toolbar card,
// table, pagination) share one look without each file restyling itself.
export const listScreenSx = {
  "& .MuiCard-root, & .MuiPaper-root": {
    borderRadius: `${RADIUS}px`,
    border: `1px solid ${SURFACE.border}`,
    boxShadow: "0 1px 2px rgba(16,24,40,0.04), 0 4px 16px rgba(16,24,40,0.04)",
  },
  // Toolbar
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#fff",
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#b6c4e0" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: ACCENT },
  },
  "& .MuiButton-root": {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 700,
  },
  // Table
  "& .MuiTableCell-head": {
    backgroundColor: ACCENT,
    color: "#fff",
    fontWeight: 600,
    textTransform: "none",
    borderBottom: `1px solid ${SURFACE.border}`,
  },
  "& .MuiTableCell-head .MuiTableSortLabel-root, & .MuiTableCell-head .MuiTableSortLabel-root:hover, & .MuiTableCell-head .MuiTableSortLabel-root.Mui-active, & .MuiTableCell-head .MuiTableSortLabel-icon, & .MuiTableCell-head .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon": {
    color: "#fff !important",
  },
  "& .MuiTableCell-head .MuiCheckbox-root, & .MuiTableCell-head .MuiCheckbox-root.Mui-checked, & .MuiTableCell-head .MuiCheckbox-root.MuiCheckbox-indeterminate": {
    color: "#fff",
  },
  "& .MuiTableBody-root .MuiTableRow-root": {
    transition: "background-color 0.15s",
  },
  "& .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd)": {
    backgroundColor: "transparent",
  },
  "& .MuiTableBody-root .MuiTableRow-root:hover": {
    backgroundColor: ACCENT_SOFT,
  },
  "& .MuiTableBody-root .MuiTableCell-root": {
    borderBottom: "1px solid #eef1f6",
  },
  "& .MuiTableBody-root .MuiIconButton-root": {
    borderRadius: "8px",
  },
  "& .MuiTablePagination-root": {
    backgroundColor: "#fafbfd",
    borderTop: `1px solid ${SURFACE.border}`,
  },
};
